export const trapezoid_course_angles = {
    "60°, 120° Start finish together. Reach = half beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 330,
        "angle-m4-m3": 300,
        "I": {
            "2": {
                "scale-m4-m1": 0.22,
                "scale-m4-m2": 0.19,
                "scale-m4-m3": 0.11,
            },
            "3": {
                "scale-m4-m1": 0.153,
                "scale-m4-m2": 0.132,
                "scale-m4-m3": 0.076,
            },
            "4": {
                "scale-m4-m1": 0.117,
                "scale-m4-m2": 0.101,
                "scale-m4-m3": 0.058,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.282,
                "scale-m4-m2": 0.244,
                "scale-m4-m3": 0.141,
            },
            "3": {
                "scale-m4-m1": 0.22,
                "scale-m4-m2": 0.19,
                "scale-m4-m3": 0.11,
            },
            "4": {
                "scale-m4-m1": 0.18,
                "scale-m4-m2": 0.156,
                "scale-m4-m3": 0.09,
            },
        }
    },
    "70°, 110° Start finish together. Reach = half beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 330,
        "angle-m4-m3": 290,
        "I": {
            "2": {
                "scale-m4-m1": 0.212,
                "scale-m4-m2": 0.202,
                "scale-m4-m3": 0.106,
            },
            "3": {
                "scale-m4-m1": 0.149,
                "scale-m4-m2": 0.142,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.115,
                "scale-m4-m2": 0.109,
                "scale-m4-m3": 0.057,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.249,
                "scale-m4-m2": 0.237,
                "scale-m4-m3": 0.124,
            },
            "3": {
                "scale-m4-m1": 0.187,
                "scale-m4-m2": 0.179,
                "scale-m4-m3": 0.094,
            },
            "4": {
                "scale-m4-m1": 0.15,
                "scale-m4-m2": 0.143,
                "scale-m4-m3": 0.075,
            },
        }
    },
    "60°, 120° Separate Start finish. Reach = half beat length": {
      "angle-m4-m1": 0,
      "angle-m4-m2": 330,
      "angle-m4-m3": 240,
      "I": {
            "2": {
                "scale-m4-m1": 0.216,
                "scale-m4-m2": 0.187,
                "scale-m4-m3": 0.108,
            },
            "3": {
                "scale-m4-m1": 0.151,
                "scale-m4-m2": 0.131,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.116,
                "scale-m4-m2": 0.1,
                "scale-m4-m3": 0.058,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.216,
                "scale-m4-m2": 0.187,
                "scale-m4-m3": 0.108,
            },
            "3": {
                "scale-m4-m1": 0.151,
                "scale-m4-m2": 0.131,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.116,
                "scale-m4-m2": 0.1,
                "scale-m4-m3": 0.058,
            },
        }
    },
    "70°, 110° Separate Start finish. Reach = half beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 330,
        "angle-m4-m3": 250,
        "I": {
            "2": {
                "scale-m4-m1": 0.216,
                "scale-m4-m2": 0.206,
                "scale-m4-m3": 0.108,
            },
            "3": {
                "scale-m4-m1": 0.151,
                "scale-m4-m2": 0.144,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.116,
                "scale-m4-m2": 0.11,
                "scale-m4-m3": 0.058,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.216,
                "scale-m4-m2": 0.206,
                "scale-m4-m3": 0.108,
            },
            "3": {
                "scale-m4-m1": 0.151,
                "scale-m4-m2": 0.144,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.116,
                "scale-m4-m2": 0.11,
                "scale-m4-m3": 0.058,
            },
        }
    },
    "60°, 120° Equal beats. Reach = half beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 330,
        "angle-m4-m3": 240,
        "I": {
            "2": {
                "scale-m4-m1": 0.216,
                "scale-m4-m2": 0.187,
                "scale-m4-m3": 0.108,
            },
            "3": {
                "scale-m4-m1": 0.151,
                "scale-m4-m2": 0.131,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.116,
                "scale-m4-m2": 0.1,
                "scale-m4-m3": 0.058,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.216,
                "scale-m4-m2": 0.187,
                "scale-m4-m3": 0.108,
            },
            "3": {
                "scale-m4-m1": 0.151,
                "scale-m4-m2": 0.131,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.116,
                "scale-m4-m2": 0.1,
                "scale-m4-m3": 0.058,
            },
        }
    },
    "70°, 110° Equal beats. Reach = half beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 330,
        "angle-m4-m3": 250,
        "I": {
            "2": {
                "scale-m4-m1": 0.216,
                "scale-m4-m2": 0.206,
                "scale-m4-m3": 0.108,
            },
            "3": {
                "scale-m4-m1": 0.151,
                "scale-m4-m2": 0.144,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.116,
                "scale-m4-m2": 0.11,
                "scale-m4-m3": 0.058,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.216,
                "scale-m4-m2": 0.206,
                "scale-m4-m3": 0.108,
            },
            "3": {
                "scale-m4-m1": 0.151,
                "scale-m4-m2": 0.144,
                "scale-m4-m3": 0.075,
            },
            "4": {
                "scale-m4-m1": 0.116,
                "scale-m4-m2": 0.11,
                "scale-m4-m3": 0.058,
            },
        }
    },

    "60°, 120° Reach = 2/3 beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 319,
        "angle-m4-m3": 240,
        "I": {
            "2": {
                "scale-m4-m1": 0.205,
                "scale-m4-m2": 0.18,
                "scale-m4-m3": 0.136,
            },
            "3": {
                "scale-m4-m1": 0.143,
                "scale-m4-m2": 0.126,
                "scale-m4-m3": 0.096,
            },
            "4": {
                "scale-m4-m1": 0.111,
                "scale-m4-m2": 0.098,
                "scale-m4-m3": 0.074,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.205,
                "scale-m4-m2": 0.18,
                "scale-m4-m3": 0.136,
            },
            "3": {
                "scale-m4-m1": 0.143,
                "scale-m4-m2": 0.126,
                "scale-m4-m3": 0.096,
            },
            "4": {
                "scale-m4-m1": 0.111,
                "scale-m4-m2": 0.098,
                "scale-m4-m3": 0.074,
            },
        }
    },
    "70°, 110° Reach = 2/3 beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 321,
        "angle-m4-m3": 250,
        "I": {
            "2": {
                "scale-m4-m1": 0.201,
                "scale-m4-m2": 0.201,
                "scale-m4-m3": 0.134,
            },
            "3": {
                "scale-m4-m1": 0.143,
                "scale-m4-m2": 0.143,
                "scale-m4-m3": 0.096,
            },
            "4": {
                "scale-m4-m1": 0.111,
                "scale-m4-m2": 0.111,
                "scale-m4-m3": 0.074,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.201,
                "scale-m4-m2": 0.201,
                "scale-m4-m3": 0.134,
            },
            "3": {
                "scale-m4-m1": 0.143,
                "scale-m4-m2": 0.143,
                "scale-m4-m3": 0.096,
            },
            "4": {
                "scale-m4-m1": 0.111,
                "scale-m4-m2": 0.111,
                "scale-m4-m3": 0.074,
            },
        }
    },
    "60°, 120° Windward, Equal beats, Reach = 2/3 beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 319,
        "angle-m4-m3": 240,
        "angle-m4-m5": 180,
        "I": {
            "2": {
                "scale-m4-m1": 0.17,
                "scale-m4-m2": 0.15,
                "scale-m4-m3": 0.113,
                "scale-m4-m5": 0.113,
                "scale-m5-fm": 0.054,
            },
            "3": {
                "scale-m4-m1": 0.124,
                "scale-m4-m2": 0.109,
                "scale-m4-m3": 0.082,
                "scale-m4-m5": 0.082,
                "scale-m5-fm": 0.038,
            },
            "4": {
                "scale-m4-m1": 0.099,
                "scale-m4-m2": 0.087,
                "scale-m4-m3": 0.066,
                "scale-m4-m5": 0.066,
                "scale-m5-fm": 0.03,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.17,
                "scale-m4-m2": 0.15,
                "scale-m4-m3": 0.113,
                "scale-m4-m5": 0.113,
                "scale-m5-fm": 0.054,
            },
            "3": {
                "scale-m4-m1": 0.124,
                "scale-m4-m2": 0.109,
                "scale-m4-m3": 0.082,
                "scale-m4-m5": 0.082,
                "scale-m5-fm": 0.038,
            },
            "4": {
                "scale-m4-m1": 0.099,
                "scale-m4-m2": 0.087,
                "scale-m4-m3": 0.066,
                "scale-m4-m5": 0.066,
                "scale-m5-fm": 0.03,
            },
        }
    },
    // "Laser and Laser Radial 70°, 110°"
    "70°, 110° Windward, Equal beats, Reach = 2/3 beat length": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 321,
        "angle-m4-m3": 250,
        "angle-m4-m5": 180,
        "I": {
            "2": {
                "scale-m4-m1": 0.175,
                "scale-m4-m2": 0.174,
                "scale-m4-m3": 0.117,
                "scale-m4-m5": 0.08,
                "scale-m5-fm": 0.054,
            },
            "3": {
                "scale-m4-m1": 0.13,
                "scale-m4-m2": 0.129,
                "scale-m4-m3": 0.086,
                "scale-m4-m5": 0.059,
                "scale-m5-fm": 0.04,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.175,
                "scale-m4-m2": 0.174,
                "scale-m4-m3": 0.117,
                "scale-m4-m5": 0.08,
                "scale-m5-fm": 0.054,
            },
            "3": {
                "scale-m4-m1": 0.13,
                "scale-m4-m2": 0.129,
                "scale-m4-m3": 0.086,
                "scale-m4-m5": 0.059,
                "scale-m5-fm": 0.04,
            },
        }
    },
    "60°, 120° Windward, Equal beats, Reach = 2/3 beat, Start finish together": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 319,
        "angle-m4-m3": 240,
        "angle-m4-m5": 180,
        "I": {
            "2": {
                "scale-m4-m1": 0.17,
                "scale-m4-m2": 0.15,
                "scale-m4-m3": 0.113,
                "scale-m4-m5": 0.113,
                "scale-m5-fm": 0.054,
            },
            "3": {
                "scale-m4-m1": 0.124,
                "scale-m4-m2": 0.109,
                "scale-m4-m3": 0.082,
                "scale-m4-m5": 0.082,
                "scale-m5-fm": 0.038,
            },
            "4": {
                "scale-m4-m1": 0.099,
                "scale-m4-m2": 0.087,
                "scale-m4-m3": 0.066,
                "scale-m4-m5": 0.066,
                "scale-m5-fm": 0.03,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.17,
                "scale-m4-m2": 0.15,
                "scale-m4-m3": 0.113,
                "scale-m4-m5": 0.113,
                "scale-m5-fm": 0.054,
            },
            "3": {
                "scale-m4-m1": 0.124,
                "scale-m4-m2": 0.109,
                "scale-m4-m3": 0.082,
                "scale-m4-m5": 0.082,
                "scale-m5-fm": 0.038,
            },
            "4": {
                "scale-m4-m1": 0.099,
                "scale-m4-m2": 0.087,
                "scale-m4-m3": 0.066,
                "scale-m4-m5": 0.066,
                "scale-m5-fm": 0.03,
            },
        }
    },
    // "Laser and Laser Radial 70°, 110°"
    "70°, 110° Windward, Equal beats, Reach = 2/3 beat, Start finish together": {
        "angle-m4-m1": 0,
        "angle-m4-m2": 321,
        "angle-m4-m3": 250,
        "angle-m4-m5": 180,
        "I": {
            "2": {
                "scale-m4-m1": 0.175,
                "scale-m4-m2": 0.174,
                "scale-m4-m3": 0.117,
                "scale-m4-m5": 0.08,
                "scale-m5-fm": 0.054,
            },
            "3": {
                "scale-m4-m1": 0.13,
                "scale-m4-m2": 0.129,
                "scale-m4-m3": 0.086,
                "scale-m4-m5": 0.059,
                "scale-m5-fm": 0.04,
            },
        },
        "O": {
            "2": {
                "scale-m4-m1": 0.175,
                "scale-m4-m2": 0.174,
                "scale-m4-m3": 0.117,
                "scale-m4-m5": 0.08,
                "scale-m5-fm": 0.054,
            },
            "3": {
                "scale-m4-m1": 0.13,
                "scale-m4-m2": 0.129,
                "scale-m4-m3": 0.086,
                "scale-m4-m5": 0.059,
                "scale-m5-fm": 0.04,
            },
        }
    },    
};